import React from 'react';
import './spinner.scss';

const handleStyle = (style) =>{
    return style !== undefined? style: {}
}
const Spinner = ({style, dClassName}) => {
    return <svg style={ handleStyle(style) } className={`spinning-loader ${dClassName || 'spinning-loader-default'}`}></svg>
}
export default Spinner;
